// extracted by mini-css-extract-plugin
module.exports = {"nav":"MenuNav_nav__2eBHr","active":"MenuNav_active__2vJIf"};